import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-modal-table",
  templateUrl: "./modal-table.component.html",
  styleUrls: ["./modal-table.component.scss"],
})
export class ModalTableComponent implements OnInit {
  @ViewChild("content") content: ElementRef<HTMLInputElement>;

  @Input() title: string;
  @Input() tableList: [];
  @Input() elementList;
  @Input() mastertable: string;
  @Input() filterParams = {};
  @Input() options;

  @Output() moveUpDown = new EventEmitter<any>();
  @Output() downloadFile = new EventEmitter<any>();
  @Output() valueFilterTable = new EventEmitter<any>();

  closeResult = "";

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    if (this.mastertable != undefined) {
      this.filterParams["page"] = 1;
    }
  }

  onChangeOrder(order, asc) {
    this.filterParams["asc"] = asc;
    this.filterParams["order"] = order;

    this.valueFilterTable.emit({
      filterTableJSON: this.filterParams,
    });
  }

  setPage(page) {
    this.filterParams["page"] = page;

    this.valueFilterTable.emit({
      filterTableJSON: this.filterParams,
    });
  }

  moveUp(id) {
    this.moveUpDown.emit({ move: "UP", id: id });
  }

  moveDown(id) {
    this.moveUpDown.emit({ move: "DOWN", id: id });
  }

  download(element: any) {
    this.downloadFile.emit({ id: element.hcId, release: element.hcRelease, cve: element.hcCve });
  }

  open() {
    this.modalService.open(this.content, {
      ariaLabelledBy: "modal-basic-title",
      centered: true,
      scrollable: true,
      size: 'lg'
    })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${reason}`;
        }
      );
  }

  dismiss() {
    this.modalService.dismissAll();

    this.modalService.open(this.content, {
      ariaLabelledBy: "modal-basic-title",
      centered: true,
      scrollable: true,
    })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${reason}`;
        }
      );
  }
}
